import { render, staticRenderFns } from "./OrHr.vue?vue&type=template&id=4cb5d230&scoped=true"
import script from "./OrHr.vue?vue&type=script&lang=js"
export * from "./OrHr.vue?vue&type=script&lang=js"
import style0 from "./OrHr.vue?vue&type=style&index=0&id=4cb5d230&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb5d230",
  null
  
)

export default component.exports